import { gql } from '@apollo/client';

export const PRICING_RUN_FIELDS = gql`
    fragment PricingRunFields on pricing_runs {
        run_id
        created_at
        status
    }
`;
